module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"link":"View on Amazon","articleCount":"Articles count","price":"Price","linkToLaptop":"Go to laptop","viewArticles":"View articles","unavailable":"Unavailable"}}')
  delete Component.options._Ctor
}
